import React from 'react';
import { potentialRoles } from '../data/corporateData';
import { Briefcase, ArrowUpRight } from 'lucide-react';

const PotentialRoles = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#0A192F]" id="roles">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="mb-12 max-w-3xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading mb-4 block">
            Future Positioning
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4 font-heading">
            Potential Leadership Roles
          </h2>
          <p className="text-base text-slate-300 leading-relaxed font-body">
            Strategic executive positions aligned with experience and industry positioning
          </p>
        </div>

        {/* Roles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="potential-roles">
          {potentialRoles.map((role) => (
            <div
              key={role.id}
              className="group bg-[#112240] border border-white/10 rounded-lg p-6 hover:border-rose-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-rose-500/10"
              data-testid={`role-card-${role.id}`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 bg-rose-500/10 rounded-lg flex items-center justify-center group-hover:bg-rose-500/20 transition-colors duration-300">
                  <Briefcase className="text-rose-500" size={24} />
                </div>
                <ArrowUpRight className="text-slate-500 group-hover:text-rose-500 transition-colors duration-300" size={20} />
              </div>

              <h3 className="text-xl font-semibold text-white mb-2 font-heading">
                {role.title}
              </h3>

              <div className="inline-block px-3 py-1 bg-rose-500/10 border border-rose-500/30 rounded-full mb-3">
                <span className="text-xs text-rose-400 font-body font-semibold">
                  {role.domain}
                </span>
              </div>

              <p className="text-sm text-slate-300 leading-relaxed font-body">
                {role.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PotentialRoles;
